// Sensor suhu yang probe-nya lepas atau rusak ngirim angka sentinel, bukan
// kosong: -999, -996, 0.00, kadang 999.99 atau 850. Endpoint lama ikut
// ngerata-ratain itu, jadi `avg` bisa keluar -995,9 dan kerender apa adanya.
//
// Rollup nyaring lewat averageTemp/observed. Endpoint lama gak punya dua field
// itu, jadi ambang BE dipakai sebagai jaring kedua.
// Sengaja nol import biar bisa dijalanin langsung pakai node.

const MIN_VALID_C = 0;
const MAX_VALID_C = 800;

// Suhu rata-rata °C, atau null kalau gak ada bacaan yang kepake. null BEDA dari
// 0 — key baru gak akan pernah ngasih 0 (bacaan 0 = probe lepas).
export function tempAverageC(channel) {
  if (!channel || channel.observed === false) return null;
  const num = Number(channel.averageTemp ?? channel.avg);
  if (!Number.isFinite(num)) return null;
  if (num <= MIN_VALID_C || num >= MAX_VALID_C) return null;
  return num;
}

export default tempAverageC;
